import { Outlet, Navigate } from 'react-router-dom'
import { BellAlertIcon } from '@heroicons/react/24/outline'
import { useAuthStore } from '@/store/auth'

export default function AuthLayout() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />
  }

  return (
    <div className="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 bg-dark-900">
      {/* Background pattern */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-accent/5 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-accent/5 rounded-full blur-3xl" />
      </div>

      <div className="relative sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <div className="w-14 h-14 rounded-xl bg-accent flex items-center justify-center">
            <BellAlertIcon className="h-8 w-8 text-dark-900" />
          </div>
        </div>
        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-cream">
          OnCall Management
        </h2>
        <p className="mt-2 text-center text-sm text-cream-muted">
          Incident Response and On-Call Scheduling
        </p>
      </div>

      <div className="relative mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-surface border border-dark-700 py-8 px-6 shadow-hard sm:rounded-xl">
          <Outlet />
        </div>
      </div>

      {/* Footer */}
      <p className="relative mt-8 text-center text-xs text-dark-500">
        &copy; {new Date().getFullYear()} OnCall Management. All rights reserved.
      </p>
    </div>
  )
}
